<template>
  <div class="page-wrapper">
    <Tabs value="name1">
      <TabPane label="房租服务费" name="name1">
        <rent :projectList="projectList"></rent>

      </TabPane>
      <TabPane label="其他收入" name="name2">
        <other :projectList="projectList"></other>

      </TabPane>
    </Tabs>
  </div>
</template>

<script>
  import Rent from './components/Rent'
  // import Other from './components/Other'
  import Other from './components/other/index'
  import {getProjects} from "@/api/common";

  export default {
    name: "income",
    components:{
      Rent,
      Other
    },
    data(){
      return {
        projectList:[]
      }

    },
    created() {
      getProjects().then(res => {
        if(!res.data){
          return
        }
        this.projectList = res.data

      }).catch(error => {
      })

    }

  }
</script>

<style scoped>

</style>
